import { lazy } from 'react';
import { createBrowserRouter, RouteObject } from 'react-router-dom';
import { paths } from './paths';
import ProtectedRoute from './protected-route';
import Login from '@/pages/login';

const Profile = lazy(() => import('@/pages/profile'));
const UserNotFound = lazy(() => import('@/pages/user-not-found'));
const NotFound = lazy(() => import('@/pages/not-found'));

const routes: RouteObject[] = [
  {
    path: paths.LOGIN,
    element: <Login />,
  },
  {
    path: paths.HOME,
    element: (
      <ProtectedRoute>
        <Profile />
      </ProtectedRoute>
    ),
  },
  {
    path: paths.USER_NOT_FOUND,
    element: (
      <ProtectedRoute>
        <UserNotFound />
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

const router = createBrowserRouter(routes);

export default router;
